import { render, staticRenderFns } from "./api.vue?vue&type=template&id=86c154ec&scoped=true"
import script from "./api.vue?vue&type=script&lang=ts"
export * from "./api.vue?vue&type=script&lang=ts"
import style0 from "./api.vue?vue&type=style&index=0&id=86c154ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c154ec",
  null
  
)

export default component.exports